import { FunctionComponent } from 'preact';
import cn from 'classnames';
import { useLayoutEffect, useMemo } from 'preact/hooks';
import { createPortal } from 'preact/compat';

interface PortalProps {
  isOpen: boolean;
}

export const PortalOverlay: FunctionComponent<PortalProps> = ({
  children,
  isOpen,
}) => {
  const element = useMemo(() => {
    const el = document.createElement('div');

    el.classList.add('vgp-portal');

    return el;
  }, []);

  useLayoutEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
  }, [isOpen]);

  useLayoutEffect(() => {
    document.body.appendChild(element);

    return () => {
      document.body.removeChild(element);
    };
  }, []);

  return createPortal(
    <div
      className={cn('vgp-portal-overlay', {
        'vgp-portal-overlay-open': isOpen,
      })}
      aria-expanded={isOpen}
    >
      <div className="vgp-portal-overlay-content">{children}</div>
    </div>,
    element
  );
};
